import { Route } from 'vue-router';
import { Store } from 'vuex';

export default function ({ route, store }: { route: Route; store: Store<any> }): void {
  // Store the previous URL in Vuex before the route changes
  store.commit('setPreviousUrl', route.fullPath);
}
